import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./SuccessModal.module.scss";

const IconRuStore = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="20" height="20" rx="5" fill="#2E7DFF" />
    <path
      d="M8 7h5.2c2.1 0 3.5 1.4 3.5 3.3 0 1.4-.8 2.5-2 3l2.3 3.7h-2.4l-2-3.3H10v3.3H8V7zm2 1.7v3.3h3c1.1 0 1.8-.7 1.8-1.7s-.7-1.6-1.8-1.6H10z"
      fill="#fff"
    />
  </svg>
);

const IconGooglePlay = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.6 2.4c-.4.4-.6 1-.6 1.7v15.8c0 .7.2 1.3.6 1.7L12 12 3.6 2.4z"
      fill="#00E1FF"
    />
    <path d="M16.3 8.3L5.6 2.1c-.5-.3-1-.3-1.4-.1L13.7 12l2.6-3.7z" fill="#00E676" />
    <path
      d="M20.6 10.6l-4.3-2.3L13.7 12l2.6 3.7 4.3-2.3c1.2-.7 1.2-2.1 0-2.8z"
      fill="#FFC400"
    />
    <path
      d="M4.2 21.9c.4.2.9.2 1.4-.1l10.7-6.2-2.6-3.6-9.5 9.9z"
      fill="#FF3D00"
    />
  </svg>
);

const IconApple = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.1 12.6c0-2.4 2-3.5 2.1-3.6-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.2-.8-1.6 0-3.1.9-4 2.4-1.7 3-.4 7.4 1.3 9.8.8 1.2 1.8 2.5 3.1 2.4 1.2 0 1.7-.8 3.2-.8s1.9.8 3.2.8c1.3 0 2.2-1.2 3-2.4.9-1.4 1.3-2.7 1.3-2.8-.1 0-2.6-1-2.7-4zM14.8 5.6c.6-.8 1.1-2 1-3.2-1 0-2.1.6-2.8 1.5-.6.7-1.2 1.9-1 3.1 1.1.1 2.2-.6 2.8-1.4z" />
  </svg>
);

const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 6L9 17l-5-5"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DRIVER_APP_LINKS = [
  {
    href: "https://www.rustore.ru/catalog/app/com.smarttrans.driver",
    icon: <IconRuStore />,
    small: "Доступно в",
    big: "RuStore",
  },
  {
    href: "https://play.google.com/store/apps/details?id=com.smarttrans.driver&hl=ru",
    icon: <IconGooglePlay />,
    small: "Скачать в",
    big: "Google Play",
  },
  {
    href: "https://apps.apple.com/ru/app/smart-taxi-%D0%B2%D0%BE%D0%B4%D0%B8%D1%82%D0%B5%D0%BB%D1%8C/id6502894777",
    icon: <IconApple />,
    small: "Загрузите в",
    big: "App Store",
  },
];

const SuccessModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  const handleClose = () => {
    onClose();
    navigate("/");
  };

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="successTitle"
      onClick={handleClose}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.checkCircle}>
          <IconCheck />
        </div>

        <h1 id="successTitle" className={styles.title}>
          Заявка отправлена!
        </h1>

        <p className={styles.text}>
          Добро пожаловать в семью <strong>SMART Taxi</strong>.
          <br />
          Скачайте приложение <strong>SMART Taxi Водитель</strong> и авторизуйтесь
          в нём.
        </p>

        <div className={styles.storeGrid}>
          {DRIVER_APP_LINKS.map((s) => (
            <a
              key={s.href}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.storeBtn}
            >
              <span className={styles.storeIcon}>{s.icon}</span>
              <span className={styles.storeText}>
                <small>{s.small}</small>
                <strong>{s.big}</strong>
              </span>
            </a>
          ))}
        </div>

        <button
          type="button"
          className={styles.closeBtn}
          onClick={handleClose}
        >
          На главную
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
